import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: `${theme.spacing.space12}px ${theme.spacing.space8}px`,
    position: "fixed",
    background: theme.colors.background1,
    top: 0,
    width: "100%",
    boxSizing: "border-box",
    zIndex: theme.zIndex.appBar,
    height: 70,
  },
  leftElement: {
    position: "absolute",
    insetInlineStart: theme.spacing.space8,
  },
  rightElement: {
    position: "absolute",
    insetInlineEnd: theme.spacing.space8,
  },
  title: {
    textTransform: "capitalize",
  },
}));
